export default __webpack_public_path__ + "static/media/logo-company-7.dcc81c96.png";